module.exports = __webpack_public_path__ + "img/438.8f1a32cc.png";